// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"mp-z","breadcrumbForward":"np-z","breadcrumbBack":"op-z","selected":"pp-z"};